export const masterConst = {
    OnShowKeyboard: "OnShowKeyboard",
    OnHideKeyboard: "OnHideKeyboard",

    OnInputChange: "OnInputChange",
    OnInputSetText: "OnInputSetText",

    OnInstallPwa: "OnInstallPwa",
    H5_UUID: "H5_UUID"

}
